import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const DotWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 1rem auto 0;
`;

const Dot = styled.div`
  width: 8px;
  height: 8px;
  background-color: ${props =>
    props.theme.carvana[props.isCurrent ? 'darkBlue2' : 'grayTwo']};
  border-radius: 50%;
  border: 1px solid
    ${props => props.theme.carvana[props.isCurrent ? 'darkBlue2' : 'grayTwo']};
  margin-left: 10px;

  &:hover {
    cursor: pointer;
  }
`;

const NavigationDots = ({ currentItem, count, onClick }) => {
  return (
    <DotWrapper>
      {Array.from(Array(count).keys()).map(x => (
        <Dot key={x} isCurrent={x === currentItem} onClick={() => onClick(x)} />
      ))}
    </DotWrapper>
  );
};

NavigationDots.propTypes = {
  count: PropTypes.number,
  currentItem: PropTypes.number,
  onClick: PropTypes.func
};

NavigationDots.defaultProps = {
  count: 0,
  currentItem: 0,
  onClick: () => {}
};

export default NavigationDots;
